<template>
   <div class="main-container">
     <!-- Your component's content here -->
   </div>
</template>
<script>
import BaseComponent from '@/mixins/BaseComponent'
import LocalStorage from '@/ultils/local-storage'
import axios from 'axios'
import FtthStorage from '@/ultils/ftth-storage'

export default {
   name: 'CallBackLogin',
   mixins: [BaseComponent],
   data() {
      return {
         code: '',
         accessToken: '',
         refreshToken: '',
         phone: '',
         apiConfig: {
            method: 'post',
            url: '',
            data: null,
            headers: { 'Content-Type': 'application/json' },
            dataType: 'json',
            contentType: 'application/json'
         }
      }
   },
   created() {
      this.verify()
   },
   methods: {
      verify() {
         this.showLoading()
         let self = this
         this.apiConfig['method'] = 'post'
         this.apiConfig['url'] = process.env.VUE_APP_VERIFY_API
         this.apiConfig['data'] = {
            code: this.$route.query.code || this.$route.query.authorization_code,
            clientSecret: process.env.VUE_APP_SECRET_KEY,
            clientId: process.env.VUE_APP_CLIENT_ID
         }
         axios(this.apiConfig)
            .then(function (response) {
               self.hideLoading()
               if (response.data.statusCode == 'THIRDPARTY1206') {
                  self.accessToken = response.data.data.accessToken
                  self.refreshToken = response.data.data.refreshToken
                  self.findPhone()
               } else {
                  self.$router.push('/login')
                  self.$store.dispatch('setNotification', { content: response.data.error })
               }
            })
            .catch(function () {
               self.hideLoading()
               self.$router.push('/login')
               self.$store.dispatch('setNotification', { content: self.$i18n.t('errors.system') })
            })
      },
      findPhone() {
         this.showLoading()
         let self = this
         this.apiConfig['method'] = 'get'
         this.apiConfig['url'] = process.env.VUE_APP_FIND_PHONE_API
         this.apiConfig['headers']['Authorization'] = `Bearer ${this.accessToken}`
         this.apiConfig['headers']['x-api-key'] = process.env.VUE_APP_CLIENT_ID

         axios(this.apiConfig)
            .then(function (response) {
               self.hideLoading()
               if (response.data.statusCode == 'USER1200') {
                  if (response.data && response.data.data && Array.isArray(response.data.data.phoneNumber)) {
                     // Lấy mảng phoneNumber
                     const phoneNumbers = response.data.data.phoneNumber;

                     // Tìm số điện thoại có primary = true
                     const primaryNumber = phoneNumbers.find(item => item.primary === true);

                     // Nếu tìm thấy, dùng số đó, nếu không thì dùng số đầu tiên
                     self.phone = primaryNumber ? primaryNumber.phoneNumber : phoneNumbers[0]?.phoneNumber || null;
                  } else {
                     // Trường hợp mảng không hợp lệ
                     self.phone = null;
                  }

                  self.addTokenLogin()
               } else {
                  self.$router.push('/login')
                  self.$store.dispatch('setNotification', { content: response.data.message })
               }
            })
            .catch(function () {
               self.$router.push('/login')
               self.$store.dispatch('setNotification', { content: self.$i18n.t('errors.system') })
               self.hideLoading()
            })
      },
      addTokenLogin() {
         this.showLoading()
         let self = this
         this.apiConfig['method'] = 'post'
         this.apiConfig['url'] = process.env.VUE_APP_ADD_TOKEN_LOGIN_API
         this.apiConfig['headers']['Authorization'] = `Bearer ${this.accessToken}`
         this.apiConfig['data'] = {
            username: this.phone,
            appCode: 'MyVTG',
            language: LocalStorage.getItem('lang')
         }

         axios(this.apiConfig)
            .then(function (response) {
               if (!response.data.errorMessage) {
                  let userInfo = {
                     token: response.data.token,
                     isdn: response.data.username,
                     sessionId: response.data.sessionId
                  }
                  var addAccount = LocalStorage.getItem('add_account_ftth')
                  if(addAccount) {
                     self.getListFtthAccountInfo(userInfo)
                  } else {
                     LocalStorage.setItem('user_info', JSON.stringify(userInfo))
                     self.$router.push('/home')
                  }
               } else {
                  self.$router.push('/login')
                  self.$store.dispatch('setNotification', { content: response.data.errorMessage })
               }
            })
            .catch(function () {
               self.$router.push('/login')
               self.$store.dispatch('setNotification', { content: self.$i18n.t('errors.system') })
            })
            .finally(() => {
               self.hideLoading()
            })
      },
      getListFtthAccountInfo(userInfo) {
         let self = this
         let data = {
            language: 'en',
            sessionId: userInfo.sessionId,
            token: userInfo.token,
            wsCode: 'wsGetListAccountFtthSameCust',
            wsRequest: {
               isdn: userInfo.isdn,
               language: 'en'
            }
         }
         let config = {
            method: 'post',
            url: process.env.VUE_APP_API,
            data: data,
            headers: { 'Content-Type': 'application/json' },
            dataType: 'json',
            contentType: 'application/json'
         }
         axios(config).then(function (response) {
            if (response.data.errorCode === 'S200') {
               var data = response.data.result.wsResponse.data ?? []
               console.log('data: ', data)
               FtthStorage.addAccount(JSON.stringify(data))
            }
         }).finally(() => {
            self.$router.push('/home')
            self.hideLoading()
         })
      }
   }
}
</script>
